import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getPropsFromMeta } from "../../utils";
import CompMeta from '../../meta/LowCodeComponents/Table';
const TABLETYPE = ["simpleTable", "editTable"];

/**
 * @class NCTable
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCTable
 * @label 表格
 *
 */
class NCTable extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
         * @title 区域编码
         * @description 区域编码
         */
        moduleId: PropTypes.string.isRequired,
        /**
        * @title 表格类型
        * @description 表格类型
        * @enumNames ['不可编辑表格', '可编辑表格']
        */
        tableType: PropTypes.oneOf(TABLETYPE),
        /**
         * @title 显示序号
         * @description 显示序号
         */
        showIndex: PropTypes.bool,
        /**
         * @title 显示复选框
         * @description 显示复选框
         */
        showCheck: PropTypes.bool,
        /**
         * @title 是否滚动加载
         * @description 是否滚动加载
         */
        height: PropTypes.number,
        /**
         * @title 是否滚动加载
         * @description 是否滚动加载
         */
        lazyload: PropTypes.bool,
        /**
         * @title 是否自适应高度
         * @description 是否自适应高度
         */
        adaptionHeight: PropTypes.bool,
        /**
         * @title 是否显示多行
         * @description 是否显示多行
         */
        multipleRowCell: PropTypes.bool,
        /**
          * @title 行样式
          * @description 行样式
          */
        rowClassName: PropTypes.string,
        /**
         * @title 跨页多选 ---------------------simpletable独有
         * @description 跨页多选
         */
        crossPageSelect: PropTypes.bool,
        /**
         * @title 是否取消右键菜单
         * @description 是否取消右键菜单
         */
        cancelCustomRightMenu: PropTypes.bool,
        /**
         * @title 是否增加空白列
         * @description 是否增加空白列
         */
        addBlankCol: PropTypes.bool,
        /**
         * @title 显示宽高配置
         * @description 显示宽高配置
         */
        showWidthAndHeightConfig: PropTypes.bool,
        /**
         * @title 多行展示是否显示全部内容
         * @description 多行展示是否显示全部内容
         */
        bodyExpandAllInRow: PropTypes.bool,
        /**
         * @title 是否在弹窗内
         * @description 是否在弹窗内
         */
        inModal: PropTypes.bool,
        /**
         * @title 行点击是否勾选
         * @description 行点击是否勾选
         */
        disableRowClickSelect: PropTypes.bool,
        /**
         * @title 最后一行录入数据自动增行
         * @description 最后一行录入数据自动增行
         */
        isAddRow: PropTypes.bool,
        /**
         * @title 隐藏右键菜单
         * @description 隐藏右键菜单
         */
        hideRightMenu: PropTypes.bool,
        /**
         * @title 活动索引
         * @description 活动索引
         */
        focusIndex: PropTypes.number,
        /**
         * @title 是否需要排序
         * @description 是否需要排序
         */
        isSort: PropTypes.bool,
        /**
        * @title 是否可见
        * @description 是否可见
        */
        visible: PropTypes.bool,

    }
    static defaultProps = {
        showIndex: true,
        showCheck: true,
        lazyload: true,
        adaptionHeight: true,
        isAddRow: false,
        inModal: false,
        tableType: "simpleTable"
    }
    static getCompMeta() {
        return CompMeta;
    }

    renderEditTable = () => {
        const { editTable, moduleId, config = {} } = this.props;
        const { createEditTable } = editTable;
        const configProps = getPropsFromMeta(this.props, NCTable.getCompMeta());
        return (
            <div className="nc-bill-table-area">
                {createEditTable(moduleId, Object.assign(configProps, config))}
            </div>
        );
    }

    renderSimpleTable = () => {
        const { table, moduleId, config = {}, dataSource } = this.props;
        const { createSimpleTable } = table;
        config.dataSource = dataSource;
        //暂时放开
        config.showCheck = true;
        config.showIndex = true;
        const configProps = getPropsFromMeta(this.props, NCTable.getCompMeta());
        return (
            <div className="nc-bill-table-area">
                {createSimpleTable(moduleId, Object.assign(configProps, config))}
            </div>
        );
    }

    renderComp() {
        const { moduleId, meta, tableType } = this.props;
        const metaData = meta.getMeta();
        const tableMetaData = metaData[moduleId];
        let ret = null;
        if (tableMetaData && tableType) {
            if (tableType === TABLETYPE[0]) {
                ret = this.renderSimpleTable();
            } else {
                ret = this.renderEditTable();
            }
        } else {
            ret = (
                <div>没有绑定模板数据</div>
            )
        }
        return ret;
    }

    render() {
        return (
            <React.Fragment>
                {this.renderComp()}
            </React.Fragment>
        )
    }
}

export default NCTable;
